// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sending-to-collection {\n  -webkit-transform: scale(0.1) translate(-50%, -50%);\n          transform: scale(0.1) translate(-50%, -50%);\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n", ""]);
// Exports
module.exports = exports;
